/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Author/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Author({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Events/Content/Content/Content/Content/Events/Content/Compact/Past/Content/Content/NotesHeader/Notes/Content/NotesCell/Content/Note/Author"
  
}) {
let noteAuthorUserPersonValueData = fromData.useDataFormat({ viewPath,
context: 'note',
path: 'author_user.person',
format: fromHelpers.author,
})
let dtColorsNeutral800 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.800'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="note.author_user.person"
 format="helpers.js author"
 text={noteAuthorUserPersonValueData}
 color={dtColorsNeutral800}
 weight="bold"
 noTitle={true}
/>
{children}
</React.Fragment>)
}